<template>
  <lord-icon
    v-if="closeable"
    @click="close"
    class="emat-close"
    src="https://cdn.lordicon.com/dfyonbvl.json"
    trigger="hover"
    :colors="getColors"
    style="width:36px; height:36px">
  </lord-icon>
</template>

<script>
export default {
  name: 'EmatClose',
  props: {
    closeable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit('click', false);
      this.$emit('close');
    },
  },
  computed: {
    getColors() {
      let primaryColor = '#196CAE';
      let secondaryColor = '#34BBDA';

      return 'primary:' + primaryColor + ',' + 'secondary:' + secondaryColor;
    },
  },
};
</script>
